module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[67]310.7ca152f.woff2";